import Aside from "./Aside"
import Nav from "./Nav"
import Main from "./Main"

// eslint-disable-next-line
export default {
	Aside,
	Nav,
	Main
}
